import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

type TagType = 'A' | 'HK' | 'US' | 'KS' | 'AU' | 'CA' | 'FR' | 'GR' | 'JP' | 'UK' | 'TH' | 'TW' | 'SG' | 'OTHER'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    market: null
  },
  setup(__props: any) {

const props = __props as {
  market?: string
};



const normalizeTagType = (value?: string): TagType => {
  const type = String(value || '').toUpperCase()
  if (['SZ', 'SH', 'A'].includes(type)) return 'A'
  if (['HK', 'US', 'KS', 'AU', 'CA', 'FR', 'GR', 'JP', 'UK', 'TH', 'TW', 'SG'].includes(type)) {
    return type as TagType
  }
  return 'OTHER'
}

const TAG_STYLE_MAP: Record<TagType, { backgroundColor: string, color: string }> = {
  A: { backgroundColor: '#DBEAFE', color: '#1F40AF' },
  HK: { backgroundColor: '#FDEA9D', color: '#92400D' },
  US: { backgroundColor: '#FFE9B4', color: '#FFB400' },
  KS: { backgroundColor: '#EEE4A0', color: '#8D7F05' },
  AU: { backgroundColor: '#F6E6B8', color: '#886301' },
  CA: { backgroundColor: '#E0D9BD', color: '#54443A' },
  FR: { backgroundColor: '#D2E5FF', color: '#3B83F6' },
  GR: { backgroundColor: '#DEDEDE', color: '#2C2C2FE5' },
  JP: { backgroundColor: '#F3E9FF', color: '#7E22CF' },
  UK: { backgroundColor: '#E4ECFF', color: '#4561A2' },
  TH: { backgroundColor: '#DFC4FF', color: '#A13FFC' },
  TW: { backgroundColor: '#FFDCCA', color: '#FF7127' },
  SG: { backgroundColor: '#FFE0E3', color: '#DC3545' },
  OTHER: { backgroundColor: '#D1FAE5', color: '#28A745' }
}

const tagType = computed(() => normalizeTagType(props.market))
const tagStyle = computed(() => TAG_STYLE_MAP[tagType.value])
const rawMarket = computed(() => String(props.market || '').toUpperCase())
const tagLabel = computed(() => {
  if (tagType.value === 'A') return rawMarket.value || 'A'
  if (tagType.value === 'OTHER') return 'Other'
  return tagType.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "market-tag",
    style: _normalizeStyle(_unref(tagStyle))
  }, _toDisplayString(_unref(tagLabel)), 5))
}
}

})